<template>
  <v-card class="pa-4">
    <v-card-title class="primary--text">
      <h1 style="width: 100%; text-align: center;">Enviar notificação para clientes</h1>
    </v-card-title>
    <v-card-text>
      <v-select v-if="posto && posto.is_simultaneo" v-model="notification.topic" label="Para Clientes"
        hint="Aplicativo que receberá a notificação" full-width persistent-hint required :items="topics" />
      <v-text-field v-if="cliente && cliente.pessoa" v-model="cliente.pessoa.nome_completo" label="Para" full-width
        persistent-hint required readonly maxlength="100" :rules="[(v) => !!v || 'Esse campo é obrigatório']" />
      <v-text-field v-model="notification.title" label="Título" full-width persistent-hint required maxlength="100"
        :rules="[(v) => !!v || 'Esse campo é obrigatório']" />
      <v-divider></v-divider>
      <v-textarea v-model="notification.message" label="Mensagem" counter maxlength="250" full-width single-line
        required :rules="[(v) => !!v || 'Esse campo é obrigatório']" />

      <v-divider></v-divider>
    </v-card-text>
    <v-card-actions>
      <v-btn small round @click="fechar">Voltar</v-btn>
      <v-spacer></v-spacer>
      <v-btn small round color='primary' :disabled="!notification.title || !notification.message" @click="enviar">
        Enviar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: ['cliente'],
  data () {
    return {
      notification: {
        message: '',
        title: '',
        topic: '',
        to: null
      },
      topics: []
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    }
  },
  beforeMount () {
    if (this.posto) {
      this.notification.topic = 'todos-usuarios'
      this.topics = [
        { text: 'Do seu posto na Apetrus', value: this.posto.cnpj },
        { text: 'Do seu aplicitivo', value: 'todos-usuarios' }
      ]
    }
    if (this.cliente) {
      this.notification.to = this.cliente.pessoa.id_pessoa
    }
  },
  methods: {
    enviar () {
      this.$store.dispatch('pushNotification', this.notification).then(() => {
        this.$emit('sucesso', 'Notificação enviada com sucesso')
        this.fechar()
      }).catch(() => {
        this.$emit('erro', 'Não foi possível enviar notificação')
      })
    },
    fechar () {
      this.notification = { message: '', title: '' }
      this.$emit('fechar')
    }
  }
}
</script>
